// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3vw7J","dragIcon":"SortableItem_dragIcon__3xsMW","disabled":"SortableItem_disabled__1lBU-"};